import { ErrorView } from '@modules/components';
import { LogoutButton } from '@modules/Organizations/LogoutButton';

export function LogoutFallback() {
  return <ErrorView secondaryAction={<LogoutButton />} />;
}
